module.exports = __webpack_public_path__ + "static/media/a65.152bc7a6.jpg";